/**
 * The size of the VIDEO CARD on the intro screen (spec 2026-10-23 §4.1, owner
 * input: "a small screen, square or semi-square").
 *
 * The intro is a designed screen, not a full-bleed video. The card takes the
 * shape of the video and fits inside a box of (screen width − 32) × (at most
 * 55 % of the screen height), so nothing is cropped and the buttons stay on
 * the screen. The phone uses the same rule; the admin preview draws it at the
 * preview frame's size, so the owner sees the shape the member gets.
 */
export const CARD_SIDE_MARGIN = 16;
export const CARD_MAX_HEIGHT_FRACTION = 0.55;

export interface CardSizeInput {
  frameWidth: number;
  frameHeight: number;
  videoWidth: number;
  videoHeight: number;
}

export function cardSize({ frameWidth, frameHeight, videoWidth, videoHeight }: CardSizeInput): {
  width: number;
  height: number;
} {
  const boxW = frameWidth - 2 * CARD_SIDE_MARGIN;
  const boxH = frameHeight * CARD_MAX_HEIGHT_FRACTION;
  const valid = Number.isFinite(videoWidth) && Number.isFinite(videoHeight) && videoWidth > 0 && videoHeight > 0;
  // No video yet (or a broken size): a square placeholder.
  const aspect = valid ? videoWidth / videoHeight : 1;
  // Fit: as wide as the box allows, unless that makes it too tall.
  let width = boxW;
  let height = boxW / aspect;
  if (height > boxH) {
    height = boxH;
    width = boxH * aspect;
  }
  return { width: Math.round(width), height: Math.round(height) };
}
